import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, InteractionType, KeyValues5, LocalService, PageKey, PaymentGatewayServiceType, RelationShipRole, Status } from 'src/service/local.service';
import { QrPaymentService } from 'src/service/qr-payment.service';

@Component({
  selector: 'app-payment-gateway-config',
  templateUrl: './payment-gateway-config.component.html',
  styleUrl: './payment-gateway-config.component.scss'
})
export class PaymentGatewayConfigComponent {
  lstSectionConfigKeys: string[] = ["qr_payment", "table"];
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = InteractionType.None; gatewayType: PaymentGatewayServiceType;
  items: KeyValues5[] = []; RelationShipRole = RelationShipRole;

  selectedIdToEdit: string = ''; isOpenEditConfigPopup = false; isGenerateQr = false;

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private qrPaymentService: QrPaymentService, private router: Router) {

  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.gatewayType = routeParams.gatewayType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      this.configurationManagementService.ensurePageActions(PageKey.PaymentGatewayConfig, this.businessId);
      if (this.interactionType != InteractionType.User && (!this.businessId || this.businessId.length < 5)) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  onInitiate() {
    this.onLoad();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.qrPaymentService.getQrPaymentConfigs(this.localService.getLoginAsCountryCode() , this.businessId, this.gatewayType).subscribe(result => {
        this.items = result;
      });
    }
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.selectedIdToEdit = key;
        this.isOpenEditConfigPopup = true;
      } break;
      case 2: {
        this.onActiveInactiveStatus(key, ActiveInactiveFor.QrPaymentConfig);
      } break;
      case 3: {
        this.onActiveInactiveStatus(key, ActiveInactiveFor.QrPaymentConfigPrimary);
      } break;
      case 4: {
        this.router.navigate(['/payment-gateways-config' + this.localService.basicParamsString, this.businessId]);
      } break;
      case 5: {
        this.selectedIdToEdit = key;
        if (this.isGenerateQr) {
          this.isGenerateQr = false;
          setTimeout(() => {
            this.isGenerateQr = true;
          }, 500);
        } else {
          this.isGenerateQr = true;
        }
      } break;
    }
  }

  onActiveInactiveStatus(key: string, activeInactiveFor: ActiveInactiveFor) {
    this.qrPaymentService.activeInactiveStatus(key, activeInactiveFor).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        let item = this.items.find(x => x.key == key);
        if (item) {
          if (activeInactiveFor == ActiveInactiveFor.QrPaymentConfig) {
            item.v2 = item.v2 == '1' ? '0' : '1';
          } else if (activeInactiveFor == ActiveInactiveFor.QrPaymentConfigPrimary) {
            this.items.forEach(itemTemp => {
              itemTemp.v3 = itemTemp.key == key ? '1' : '0';
            });
          }
        }
      }
    });
  }

}
